export const getCompanyInfos = (state) => state.company
export const getCurrencies = (state) => state.currencies
export const getCompanyCurrency = (state) => { 
    return state?.company?.society?.currency ?? { symbol: 'CFA', iso: 'XOF', name: 'Franc', id: '', exchange: '1' }
}